import {
  SET_SM_POPUP_FEEDBACK_DATA,
  RESET_SM_POPUP_FEEDBACK_DATA,
} from "../actions";

const initialState = {
  open: false,
  feedbackKey: "",
  metadata: {},
  callback: null,
};

export const smFeedbackPopupReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SM_POPUP_FEEDBACK_DATA:
      return {
        ...action.payload,
      };
    case RESET_SM_POPUP_FEEDBACK_DATA:
      return initialState;
    default:
      return state;
  }
};
